import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { Status, StatusEditPayload } from '../cerere-status.interface';
import { CerereStatusService } from '../cerere-status.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { Observable, Subject, finalize, map } from 'rxjs';
import { Generic } from 'src/app/interfaces/generic.interface';
import { SolicitareRankService } from '../../../administration/admin-settings/solicitare-rank/solicitare-rank.service';

@Component({
	selector: 'app-edit-cerere-status',
	templateUrl: './edit-cerere-status.component.html',
	styleUrls: ['./edit-cerere-status.component.scss'],
})
export class EditCerereStatusComponent {
	// general error
	errorTitle: string = helper.dialogConfig.headers.errorAtentie;
	errorIcon: string = helper.dialogConfig.icons.error;
	errorType: string = helper.dialogConfig.icons.error;
	helper = helper;

	ranks$!: Observable<Generic[]>;

	token!: string;
	isLoading = false;
	form: FormGroup = new FormGroup({
		name: new FormControl(this.data.name, [Validators.required]),
		bg_color: new FormControl(this.data.bg_color, [Validators.required]),
		observations: new FormControl(this.data.observations),
		rank: new FormControl(this.data.rank, [Validators.required]),
		slug: new FormControl(this.data.slug, [Validators.required]),
	});

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: StatusEditPayload,
		private dialogRef: MatDialogRef<EditCerereStatusComponent>,
		private cerereStatusService: CerereStatusService,
		private notificationService: NotificationService,
		private authService: AuthService,
		private solicitareRankService : SolicitareRankService
	) {
		this.processToken();
	}

	ngOnInit() {
		this.loadRanks();
	}

	closeDialog() {
		this.dialogRef?.close({
			success: false,
		});
	}

	processToken() {
		const tokenObj = this.authService.returnTokenUser();
		tokenObj.then((token) => {
			this.token = token;
			this.cerereStatusService.setToken(token);
		});
	}

	submitForm() {
		this.isLoading = true;

		const { name, bg_color, rank, slug, observations } = this.form
			.value as Status;
		const updateStatus: StatusEditPayload = {
			id: this.data.id,
			name,
			bg_color,
			rank,
			slug,
			observations,
		};

		this.cerereStatusService
			.updateStatus(updateStatus)
			.pipe(finalize(() => (this.isLoading = false)))
			.subscribe({
				next: () => {
					this.dialogRef.close({ success: true });
				},
				error: (err) => {
					let msg;
					try {
						// try to catch the message from server
						msg = err.error.errors.message[0];
					} catch (error) {
						// controll output message
						msg = helper.dialogConfig.generalMessages.error;
					}
					this.notificationService.warningSwal(
						helper.dialogConfig.headers.errorAtentie,
						msg,
						this.errorIcon
					);
				},
			});
	}

	onHttpError(res: any) {
		if (res.errors && res.errors.message && res.errors.message.length > 0) {
			res.errors.message.forEach((msg: string) => {
				this.notificationService.warningSwal(
					this.errorTitle,
					msg,
					this.errorIcon
				);
			});
		} else {
			let msg;
			try {
				// try to catch the message from server
				msg = res.error.errors.message[0];
			} catch (error) {
				// controll output message
				msg = helper.dialogConfig.generalMessages.error;
			}
			this.notificationService.warningSwal(
				this.errorTitle,
				msg,
				this.errorIcon
			);
		}
	}

	loadRanks() {
		this.isLoading = true;
		this.ranks$ = this.solicitareRankService
			.getRanksList()
			.pipe(finalize(() => (this.isLoading = false)));
	}
}
